
import roleHelper from '../util/userRoleHelper.js'
export default {
    data() {
        return {

        }
    },
    methods: {
        userHasRole(roleId) {
            return roleHelper.userHasRole(roleId)
        }
    }
}